(function(){
  function isAirsoftFamily(){
    var path=window.location.pathname.toLowerCase();
    return path==='/collections/airsoft-milsim'||path.indexOf('/collections/airsoft-milsim-')===0;
  }
  var blocked=[
    'sq_state_guard_uniform_cards','sq_shop_all_browser','sq_books_navigation_tree',
    'sq_line_root_categories','sq_ang_navigation_safety','sq_public_safety_roots',
    'sq_line_program_tree','sq_button_tree_perfect','sq_air_force_recovery',
    'sq_line_image_dedupe','sq_bfl_hierarchy_safety','vac_state_guard_insignia_button',
    'vac_asu_checklist','vac_asu_order_image_fix','vac_collection_manufacturers',
    'vac_stabrite_browser','vac_stabrite_link_fix','vac_stock_priority',
    'sq_missing_button_images','sq_category_dedupe_guard','sq_nav_visual'
  ];
  function cleanup(){
    if(!isAirsoftFamily())return;
    var main=document.getElementById('MainContent');
    if(!main)return;
    Array.prototype.forEach.call(main.querySelectorAll('[id^="shopify-section-"]'),function(section){
      var id=String(section.id||'').toLowerCase();
      if(blocked.some(function(key){return id.indexOf(key)!==-1;})){
        section.setAttribute('data-sq-airsoft-retired','true');
        section.style.setProperty('display','none','important');
      }
    });
    Array.prototype.forEach.call(main.querySelectorAll('collection-component'),function(component){
      component.style.setProperty('display','block','important');
    });
    document.documentElement.classList.add('sq-airsoft-clean');
  }
  function boot(){
    cleanup();
    window.setTimeout(cleanup,250);
    window.setTimeout(cleanup,900);
    window.setTimeout(cleanup,2500);
    var main=document.getElementById('MainContent');
    if(main){new MutationObserver(function(){window.setTimeout(cleanup,40);}).observe(main,{childList:true,subtree:true});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
